import env from '../env';
import BaseService from './BaseService';
const url = `${env.health_backend}health/comments`;

class CommentsService extends BaseService{};

export default new CommentsService('health_backend','comments');